import capConfigure from "./widgets/configure.js";
import capInfiniteHits from "./widgets/infiniteHits.js";
import capSearchBox from "./widgets/search-box.js";
import initOnScroll from "./helpers/initOnScroll.js";
import hideSnippet from "./helpers/snippet.js";

window.addEventListener("load", function () {
	if ( !document.getElementById("contentStream") || algolia.indices.searchable_posts === undefined ) {
		return;
	}

	// instantiate instantsearch.js
	var search = instantsearch({
		indexName: algolia.indices.searchable_posts.name,
		searchClient: algoliasearch(
			algolia.application_id,
			algolia.search_api_key
		),
		onStateChange: (event) => {
			hideSnippet();
			event.setUiState(event.uiState);
		},
		routing: {
			router: instantsearch.routers.history({
				writeDelay: 1000,
			}),
			stateMapping: { // handle url parameters
				stateToRoute(indexUi) {
					const searchQuery = capAlgolia.is_search_page === 'true' ? 's' : 'qry';
					const indexUiState = indexUi[algolia.indices.searchable_posts.name];
					return {
						[searchQuery]: indexUiState.query,
						page: indexUiState.page,
						issues: indexUiState.refinementList && indexUiState.refinementList['tax_ids']['issues'],
						topics: indexUiState.refinementList && indexUiState.refinementList['tax_ids']['topics'],
					};
				},
				routeToState(routeState) {
					const searchQuery = capAlgolia.is_search_page === 'true' ? 's' : 'qry';
					const indexUiState = {};
					indexUiState[algolia.indices.searchable_posts.name] = {
						query: routeState[searchQuery],
						page: routeState.page,
						refinementList: {
							'topics': routeState.topics,
							'issues': routeState.issues,
						},
					};
					return indexUiState;
				},
			},
		},
	});

	let postFilters = JSON.parse(capAlgoliaFeedOptions.filter);
	let perPage = JSON.parse(capAlgoliaFeedOptions.per_page);

	// add search widgets
	search.addWidgets([

		capConfigure({
			searchParameters: {
				hitsPerPage: Number(perPage),
				filters: postFilters,
				distinct: true,
				// clickAnalytics: true,
			},
		}),

		// search box widget
		capSearchBox({
			container: "#cs-search-box",
			placeholder: "Search for...",
			showReset: false,
			showSubmit: false,
			showLoadingIndicator: false,
		}),

		// stats widget
		instantsearch.widgets.stats({
			container: "#algolia-stats",
			templates: {
				text(data, { html }) {
				  let count = 'Approx. ';
			
				  if (data.hasManyResults) {
					count += `${data.nbHits} results`;
				  } else if (data.hasOneResult) {
					count += `1 result`;
				  } else {
					count += `No results`;
				  }
			
				  return html`<span>${count} found</span>`;
				},
			},
		}),
		
		// results
		capInfiniteHits({
			cssClasses: {
				loadMore: 'button1',
			}
		}),
	]);

	initOnScroll(search);
});
